import API from './config'

export const StatusDpinDairAPI = {
    async getStatusesDair() {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/status_dpin_dair/getStatusesDair', config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getStatusesDairHistoricByClientId(year, clientId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/status_dpin_dair/getStatusesDairHistoricByClientId?year=${year}&client_id=${clientId}`, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getStatusesDpin() {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/status_dpin_dair/getStatusesDpin', config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getCountStatusesByMonthAndYear(month, year, isDpin) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/status_dpin_dair/getCountStatusesByMonthAndYear?month=${month}&year=${year}&is_dpin=${isDpin ? 1 : 0}`, config)

            console.log("RESPONSE DPIN: ", response);
            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getCountStatusesByClientFilter(
        year,
        advisorId,
        consultingId,
        search,
        dairStatusIdFilter,
        monthFilterDair,
        dpinStatusIdFilter,
        snapshotDate,
        isDpin) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            },
            params: {
                year,
                advisorId: advisorId ?? null,
                consultingId,
                search: search ?? "",
                dairStatusIdFilter: dairStatusIdFilter,
                monthFilterDair: monthFilterDair,
                dpinStatusIdFilter: dpinStatusIdFilter,
                snapshotDate: snapshotDate,
                is_dpin: isDpin ? 1 : 0,
            },
        }

        try {

            const response = await API.get(
                "/status_dpin_dair/getCountStatusesWithClientFilter",
                config
            );

            console.log("RESPONSE DPIN: ", response);
            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getCountStatusesXmlAudespByClientFilter(
        year,
        periodType, // 'month' | 'tri'
        period,
        advisorId,
        consultingId,
        search,
        xmlAudespStatusIdFilter,
        snapshotDate) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            },
            params: {
                year,
                periodType: periodType ?? 'month',
                period,
                advisorId: advisorId ?? null,
                consultingId,
                search: search ?? "",
                xmlAudespStatusIdFilter: xmlAudespStatusIdFilter,
                snapshotDate: snapshotDate,
            },
        }

        try {

            const response = await API.get(
                "/status_dpin_dair/getCountStatusesXmlAudespWithClientFilter",
                config
            );

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async changeStatusDpin(statusDpinId,
        clientId,
        userId,
        year) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/status_dpin_dair/changeStatusDpin', {
                status_dpin_id: statusDpinId,
                client_id: clientId,
                user_id: userId,
                year: year
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async changeStatusDair(statusDairId,
        clientId,
        userId,
        month,
        year,
        comment) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/status_dpin_dair/changeStatusDair', {
                status_dair_id: statusDairId,
                client_id: clientId,
                user_id: userId,
                month: month,
                year: year,
                comment: comment
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async saveComment(statusDairClientId, userId, comment) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/status_dpin_dair/saveComment', {
                status_dair_client_id: statusDairClientId,
                user_id: userId,
                comment: comment,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getStatusesDpinHistoricByClientId(year, clientId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/status_dpin_dair/getStatusesDpinHistoricByClientId?year=${year}&client_id=${clientId}`, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async saveCommentDpin(statusDpinClientId, userId, comment) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/status_dpin_dair/saveCommentDpin', {
                status_dpin_client_id: statusDpinClientId,
                user_id: userId,
                comment: comment,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getStatusesXmlAudesp() {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/status_dpin_dair/getStatusesXmlAudesp', config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getStatusesXmlAudespTri() {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/status_dpin_dair/getStatusesXmlAudespTri', config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async changeStatusXmlAudesp(statusXmlAudespId, clientId, userId, month, year) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/status_dpin_dair/changeStatusXmlAudesp', {
                status_xml_audesp_id: statusXmlAudespId,
                client_id: clientId,
                user_id: userId,
                month: month,
                year: year
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async changeStatusXmlAudespTri(statusXmlAudespTriId, clientId, userId, tri, year) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/status_dpin_dair/changeStatusXmlAudespTri', {
                status_xml_audesp_tri_id: statusXmlAudespTriId,
                client_id: clientId,
                user_id: userId,
                tri: tri,
                year: year
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getStatusXmlAudespHistoricByClientId(year, clientId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/status_dpin_dair/getStatusXmlAudespHistoricByClientId?year=${year}&client_id=${clientId}`, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async saveCommentXmlAudesp(statusXmlAudespClientId, userId, comment) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/status_dpin_dair/saveCommentXmlAudesp', {
                status_xml_audesp_client_id: statusXmlAudespClientId,
                user_id: userId,
                comment: comment,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async saveCommentXmlAudespTri(statusXmlAudespTriClientId, userId, comment) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/status_dpin_dair/saveCommentXmlAudespTri', {
                status_xml_audesp_tri_client_id: statusXmlAudespTriClientId,
                user_id: userId,
                comment: comment,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },
}